import { render, staticRenderFns } from "./purchasegnoreList.vue?vue&type=template&id=6b5eb54e&scoped=true"
import script from "./purchasegnoreList.vue?vue&type=script&lang=js"
export * from "./purchasegnoreList.vue?vue&type=script&lang=js"
import style0 from "./purchasegnoreList.vue?vue&type=style&index=0&id=6b5eb54e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5eb54e",
  null
  
)

export default component.exports